/// <reference types="jquery" />

import ko = require("knockout");
import Q = require("q");

import Context = require("VSS/Context");
import Service = require("VSS/Service");
import Utils_Core = require("VSS/Utils/Core");
import Utils_String = require("VSS/Utils/String");
import Utils_UI = require("VSS/Utils/UI");
import VSS = require("VSS/VSS");
import Controls_Combos = require("VSS/Controls/Combos");
import KnockoutCommon = require("DistributedTasksCommon/TFS.Knockout.CustomHandlers");
import Resources = require("DistributedTasksCommon/Resources/TFS.Resources.DistributedTasksLibrary");
import ServiceEndpoint_Common = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Common");
import ServiceEndpoint_Controls = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Controls");
import ServiceEndpoint_Utils = require("DistributedTasksCommon/ServiceEndpoints/ServiceEndpoint.Utils");
import DistributedTaskModels = require("DistributedTasksCommon/TFS.Tasks.Models");
import DistributedTask_Contracts = require("TFS/DistributedTask/Contracts");
import ServiceEndpoint_Contracts = require("TFS/ServiceEndpoint/Contracts");
import { FeatureAvailabilityService } from "VSS/FeatureAvailability/Services";
import { MarkdownRenderer } from "ContentRendering/Markdown";
import * as AzureRMEndpointsManageDialog_NO_REQUIRE from "DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog";
import TaskUtils = require("DistributedTasksCommon/TFS.Tasks.Utils");

KnockoutCommon.initKnockoutHandlers(true);

import "VSS/LoaderPlugins/Css!DistributedTasksLibrary";


export class AddDockerRegistryEndpointModel extends ServiceEndpoint_Controls.AddServiceEndpointModel {

    public dialogTemplate: string = "add_docker_connections_dialog";
    public acrPushRoleDefinitionId: string = "8311e382-0749-4cb8-b61a-304f252e45ec";

    public registrytype: KnockoutObservable<string> = ko.observable("Others");
    public authenticationScheme: KnockoutObservable<string> = ko.observable("");
    public showAzureSubscriptionBasedOption: KnockoutObservable<boolean> = ko.observable(AddDockerRegistryEndpointModel.showAzureSubscriptionBasedOption());
    public isDockerHub: KnockoutComputed<boolean> = ko.computed(() => { return this.registrytype() === "DockerHub" });
    public isOtherRegistry: KnockoutComputed<boolean> = ko.computed(() => { return this.registrytype() === "Others" });
    public isACR: KnockoutComputed<boolean> = ko.computed(() => { return this.registrytype() === "ACR" });
    public isExistingRegistryTypeACR: KnockoutComputed<boolean> = ko.computed(() => { return Utils_String.equals(this.registrytype(), "ACR", true) });
    public registry: KnockoutObservable<string> = ko.observable("https://index.docker.io/v1/");
    public email: KnockoutObservable<string> = ko.observable("");
    public pwd: KnockoutObservable<string> = ko.observable("");
    public setDockerRegistry: KnockoutComputed<void> = ko.computed(() => {
        if (this.isDockerHub()) {
            this.registry("https://index.docker.io/v1/");
        }
    });
    public description: KnockoutObservable<string> = ko.observable("");

    public azureSpnRoleAssignmentId: string = "";
    public azureSpnPermissions: string = "";
    public appObjectId: string = "";
    public spnObjectId: string = "";
    public dockerRegistryHelpMarkdown: string;

    public verifyConnectionStatus: KnockoutObservable<string> = ko.observable("");
    public verifyConnectionStatusCssTextClass: KnockoutObservable<string> = ko.observable("");
    public verifyConnectionStatusCssIconClass: KnockoutObservable<string> = ko.observable("");

    public servicePrincipalSetupInProgress: KnockoutObservable<boolean> = ko.observable(false);
    public pollingInProgress: KnockoutObservable<boolean> = ko.observable(false);
    public subscriptionList: KnockoutObservableArray<DistributedTask_Contracts.AzureSubscription> = ko.observableArray([]);
    public subscriptionId: KnockoutObservable<string> = ko.observable("");
    public subscriptionName: KnockoutObservable<string> = ko.observable("");
    public subscriptionTenantId: KnockoutObservable<string> = ko.observable("");
    public spnClientId: KnockoutObservable<string> = ko.observable("");
    public spnKey: KnockoutObservable<string> = ko.observable("");

    public oauthAccessTokenKey: KnockoutObservable<string> = ko.observable("");
    public isOAuthFlowInProgress: KnockoutObservable<boolean> = ko.observable(false);

    public refreshRegistriesList: KnockoutObservable<boolean> = ko.observable(false);
    public registriesList: KnockoutObservableArray<any> = ko.observableArray([]);
    public selectedRegistryId: KnockoutObservable<string> = ko.observable("");
    public selectedLoginServer: KnockoutObservable<string> = ko.observable("");
    public operationStatusMessage: KnockoutObservable<string> = ko.observable("");

    public registryTypeSelectorText: string = Resources.ChooseRegistryTypeText;
    public dockerRegistryAzureSubscriptionHelpText: string = Resources.DockerRegistryAzureSubscriptionHelpText;
    public azureContainerRegistryHelpText: string = Resources.AzureContainerRegistryHelpText;

    protected _distributedTaskClient: DistributedTaskModels.ConnectedServicesClientService;
    private _disposalManager: Utils_Core.DisposalManager = new Utils_Core.DisposalManager();
    
    private _ICON_CLASS_SUCCESS: string = "bowtie-status-success";
    private _ICON_CLASS_FAILURE: string = "bowtie-status-failure";
    private _TEXT_CLASS_SUCCESS: string = "vc-status-success";
    private _TEXT_CLASS_FAILURE: string = "vc-status-failure";

    public showVerifyConnection: KnockoutComputed<boolean> = this._disposalManager.addDisposable(ko.computed(() => {
        if (this.isDockerHub()) {
            return true;
        }

        return false;
    }));

    public operationStatusMessageWithPrefix = this._disposalManager.addDisposable(ko.computed(function () {
        return Resources.DockerRegistryOperationStatusMessagePrefix + this.operationStatusMessage();
    }, this));

    public selectedRegistryName = this._disposalManager.addDisposable(ko.computed(function () {
        return this.getRegistryNameFromRegistryId(this.selectedRegistryId());
    }, this));

    public registryNamesList = this._disposalManager.addDisposable(ko.computed(function () {
        const registriesList = this.registriesList();
        let registryNames: string[] = registriesList ? registriesList.map( registry => registry.name ) : [];
        return registryNames;
    }, this));

    public subscriptionAndIdList = this._disposalManager.addDisposable(ko.computed(function () {
        const subscriptionList = this.subscriptionList();
        let nameAndIdList: string[] = subscriptionList ? subscriptionList.map( subscription => subscription.displayName + " ( " + subscription.subscriptionId + " )" ) : [];
        return nameAndIdList;
    }, this));

    public subscriptionAndId = this._disposalManager.addDisposable(ko.computed({
        read: function () {
            let selectedEntry = this.subscriptionName() + " ( " + this.subscriptionId() + " )";
            return selectedEntry;
        },
        write: function (value) {
            if (value !== undefined && value !== null) {
                let indexOfSelectedEntry = this.subscriptionAndIdList().indexOf(value);
                const subscriptions = this.subscriptionList.peek();
                const selectedSubscription = subscriptions[indexOfSelectedEntry];
                this.subscriptionName(selectedSubscription.displayName);
                if (selectedSubscription.subscriptionTenantId !== this.subscriptionTenantId()) {
                    this.oauthAccessTokenKey(Utils_String.empty);
                }

                this.subscriptionTenantId(selectedSubscription.subscriptionTenantId);
                this.subscriptionId(selectedSubscription.subscriptionId);
            }
        },
        owner: this
    }));

    constructor(successCallBack: (serviceEndpoint: ServiceEndpoint_Contracts.ServiceEndpoint) => void, options?: any) {
        super(successCallBack);

        let renderer = new MarkdownRenderer();
        this.dockerRegistryHelpMarkdown = renderer.renderHtml(Resources.DockerRegistryHelpText);
        this.verifyConnectionStatus(Resources.ConnectionStatusNotVerified);

        this._disposalManager.addDisposable(this.verifyConnectionStatus.subscribe((value: string) => {
            var statusIconCssClass = "";

            if (Utils_String.equals(value, Resources.ConnectionStatusVerified, true)) {
                this.verifyConnectionStatusCssTextClass(this._TEXT_CLASS_SUCCESS);
                // add status to the icon class to get the correct color (bowtie icons are all gray)
                statusIconCssClass = [this._ICON_CLASS_SUCCESS, this.verifyConnectionStatusCssTextClass()].join(" ");
                this.verifyConnectionStatusCssIconClass(statusIconCssClass);
            }
            else if (Utils_String.equals(value, Resources.ConnectionStatusFailed, true)) {
                this.verifyConnectionStatusCssTextClass(this._TEXT_CLASS_FAILURE);
                // add status to the icon class to get the correct color (bowtie icons are all gray)
                statusIconCssClass = [this._ICON_CLASS_FAILURE, this.verifyConnectionStatusCssTextClass()].join(" ");
                this.verifyConnectionStatusCssIconClass(statusIconCssClass);
            } else {
                this.verifyConnectionStatusCssTextClass("");
                this.verifyConnectionStatusCssIconClass("");
            }
        }));

        this._disposalManager.addDisposable(this.subscriptionId.subscribe((selectedSubscription: string) => {
            if (!!selectedSubscription) {
                // refresh the resource groups dropdown when user clicks it
                this.refreshRegistriesList(true);
            }
        }));

        var connection: Service.VssConnection = new Service.VssConnection(Context.getDefaultWebContext());
        this._distributedTaskClient = connection.getService<DistributedTaskModels.ConnectedServicesClientService>(DistributedTaskModels.ConnectedServicesClientService);

    }

    public static showAzureSubscriptionBasedOption(): boolean {
        var defaultPageContext = Context.getPageContext();
        var isHosted: boolean = !!defaultPageContext.webAccessConfiguration.isHosted;
        return isHosted && FeatureAvailabilityService.isFeatureEnabled(ServiceEndpoint_Common.FeatureAvailabilityFlags.AzureSubscriptionBasedDockerRegistry, false);
    }

    public createServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        if (this.isDockerHub() || this.isOtherRegistry()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.UsernamePassword);
        }
        else if (this.isACR()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.ServicePrincipal);
        }

        return this.beginCreateServiceEndpoint();
    }

    public updateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        if (this.isDockerHub() || this.isOtherRegistry()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.UsernamePassword);
        }
        else if (this.isACR()) {
            this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.ServicePrincipal);
        }

        return this.beginUpdateServiceEndpoint();
    }

    public verifyConnection(): void {
        this.verifyConnectionStatus(Resources.ConnectionStatusVerifying);
        this.errors([]);

        // 'Verify Connection' option only exists for DockerHub registryType right now
        this.authenticationScheme(ServiceEndpoint_Common.EndpointAuthorizationSchemes.UsernamePassword);

        var resultTransformationDetails: ServiceEndpoint_Contracts.ResultTransformationDetails = {
            resultTemplate: "",
            callbackContextTemplate: "",
            callbackRequiredTemplate: ""
        };

        var dataSourceDetails: ServiceEndpoint_Contracts.DataSourceDetails = {
            dataSourceName: "TestConnection",
            dataSourceUrl: "",
            headers: null,
            requestContent: null,
            requestVerb: null,
            resourceUrl: "",
            parameters: null,
            resultSelector: "",
            initialContextTemplate: ""
        };

        var serviceEndpointDetails = this.getServiceEndpoint();

        var serviceEndpointRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest = {
            dataSourceDetails: dataSourceDetails,
            resultTransformationDetails: resultTransformationDetails,
            serviceEndpointDetails: serviceEndpointDetails.toServiceEndpointDetails()
        };

        var verifyConnectedServicePromise: IPromise<ServiceEndpoint_Contracts.ServiceEndpointRequestResult> = this.verifyConnectedService(serviceEndpointRequest, this.id());

        verifyConnectedServicePromise.then((result: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
        }, (error) => {
            this.verifyConnectionStatus(Resources.ConnectionStatusFailed);
            this.errors.push(error);
        });
    }

    public onKeyDown(data: any, event: JQueryEventObject): boolean {
        var currentElement: JQuery = $(event.target);

        switch (event.keyCode) {
            case Utils_UI.KeyCode.ENTER:
                currentElement.click();
                return false;

            case Utils_UI.KeyCode.SPACE:
                currentElement.click();
                return false;

            default:
                return true;
        }
    }

    public getServiceEndpoint(): ServiceEndpoint_Common.ServiceEndpointDetails {
        if (this.isDockerHub() || this.isOtherRegistry()) {
            return this.getServiceEndpointForDockerHub();
        }
        else if (this.isACR()) {
            return this.getServiceEndpointForAzureSubscription();
        }
    }

    private getServiceEndpointForDockerHub(): ServiceEndpoint_Common.ServiceEndpointDetails {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        var password = this.pwd();
        if (password === "" && this.isUpdate()) {
            password = null;
        }

        var registryValue = this.registry();
        if (registryValue === "") {
            registryValue = "https://index.docker.io/v1";
        }

        var endpointUrl = "https://hub.docker.com/";
        if (this.registrytype() !== "DockerHub") {
            endpointUrl = registryValue;
        }

        var apiData: ServiceEndpoint_Common.DockerRegistryServiceEndpointApiData = {
            endpointId: connectionIdTemp,
            endpointName: this.name.peek().trim(),
            description: this.description(),
            url: endpointUrl,
            username: this.userName(),
            passwordKey: password,
            registry: registryValue,
            type: ServiceEndpoint_Common.ServiceEndpointType.Docker,
            email: this.email(),
            parameters: {
                registrytype: this.registrytype()
            },
            scheme: this.authenticationScheme()
        };

        return new ServiceEndpoint_Common.DockerRegistryServiceEndpointDetails(apiData);
    }

    private getServiceEndpointForAzureSubscription(): ServiceEndpoint_Common.ServiceEndpointDetails {

        var connectionIdTemp = this.id.peek().trim();
        if (!connectionIdTemp) {
            connectionIdTemp = ServiceEndpoint_Utils.GUIDUtils.newGuid();
        }

        var apiData: ServiceEndpoint_Common.KubernetesServiceEndpointApiData = {
            endpointId: connectionIdTemp,
            endpointName: this.name.peek().trim(),
            url: `https://${ this.selectedLoginServer() }`,
            type: ServiceEndpoint_Common.ServiceEndpointType.Docker,
            scheme: this.authenticationScheme(),
            parameters: {
                registrytype: this.registrytype(),
                subscriptionId: this.subscriptionId(),
                subscriptionName: this.subscriptionName(),
                azureSpnRoleAssignmentId: this.azureSpnRoleAssignmentId,
                azureSpnPermissions: this.azureSpnPermissions,
                spnObjectId: this.spnObjectId,
                appObjectId: this.appObjectId,
                registryId: this.selectedRegistryId()
            }
        };

        var authorizationInfo: ServiceEndpoint_Contracts.EndpointAuthorization = {
            parameters: {
                tenantId: this.subscriptionTenantId(),
                servicePrincipalId: this.spnClientId().trim() || "<placeholder>",
                scope:this.selectedRegistryId(),
                loginServer: this.selectedLoginServer(),
                role: this.acrPushRoleDefinitionId
            },
            scheme: this.authenticationScheme()
        };

        if(this.oauthAccessTokenKey()) {
            authorizationInfo.parameters["accesstoken"] = this.oauthAccessTokenKey();    
            authorizationInfo.parameters["accessTokenFetchingMethod"] = ServiceEndpoint_Contracts.AccessTokenRequestType.Oauth.toString();
        }

        return new ServiceEndpoint_Common.KubernetesServiceEndpointDetails(apiData, authorizationInfo);
    }

    private beginCreateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var serviceEndpoint = this.getServiceEndpoint().toServiceEndpoint();
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        this._distributedTaskClient.beginCreateServiceEndpoint(serviceEndpoint).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {
            if (!this.isACR()) {
                defer.resolve(response);

                // Decoupling authorization from creation of endpoint.
                if(this.isPipelineAuthorizationEnabled()) {
                    this._distributedTaskClient.authorizeEndpoint(response).then(() => {}, (error) => {defer.reject(error)});
                }
            }
            else {
                this.waitForServicePrincipalSetupToComplete(response.id).then((provisionEndpointResponse) => {
                    defer.resolve(provisionEndpointResponse);

                    // Authorization is attempted after SPN setup.
                    if(this.isPipelineAuthorizationEnabled()) {
                        this._distributedTaskClient.authorizeEndpoint(provisionEndpointResponse).then(() => {}, (error) => {defer.reject(error)});
                    }
                }, (error) => {
                    try {
                        this._distributedTaskClient.beginDeleteServiceEndpoint(response.id);
                    } catch (e) {}

                    defer.reject(error);
                });
            }
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    private beginUpdateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var serviceEndpoint = this.getServiceEndpoint().toServiceEndpoint();
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        this._distributedTaskClient.beginUpdateServiceEndpoint(serviceEndpoint).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {
            TaskUtils.pickServiceEndpointNameAndDescriptionFromServiceEndpointProjectReference(response);
            if (!this.isACR() || this.isExistingRegistryTypeACR()) {
                defer.resolve(response);
            }
            else {
                this.waitForServicePrincipalSetupToComplete(response.id).then((provisionEndpointResponse) => {
                    defer.resolve(provisionEndpointResponse);
                }, (error) => {
                    defer.reject(error);
                });
            }
        }, (error) => {
            defer.reject(error);
        });
        
        return defer.promise;
    }

    private waitForServicePrincipalSetupToComplete(endpointId: string): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {

        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();
        this.servicePrincipalSetupInProgress(true);
        this.pollingInProgress(true);

        var operationStatus = { "state": "InProgress", "statusMessage": "" };
        var monitorServicePrincipalSetupProgress = new Utils_Core.DelayedFunction(this, 1000, "monitorServicePrincipalSetupProgress", () => {

            this._distributedTaskClient.beginGetEndpoint(endpointId).then((response: ServiceEndpoint_Contracts.ServiceEndpoint) => {

                if (response.operationStatus !== null && response.operationStatus !== undefined) {
                    operationStatus = response.operationStatus;
                }

                if (response.isReady) {
                    defer.resolve(response);
                    this.servicePrincipalSetupInProgress(false);
                    this.pollingInProgress(false);
                    monitorServicePrincipalSetupProgress.cancel();
                }
                else if (operationStatus.state === "Failed") {
                    defer.reject(operationStatus.statusMessage);
                    this.servicePrincipalSetupInProgress(false);
                    this.pollingInProgress(false);
                    monitorServicePrincipalSetupProgress.cancel();
                }
                else {
                    monitorServicePrincipalSetupProgress.reset();
                }
            });
        });
        monitorServicePrincipalSetupProgress.start();
        return defer.promise;
    }

    private verifyConnectedService(serviceEndpointRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest, endpointId: string): IPromise<ServiceEndpoint_Contracts.ServiceEndpointRequestResult> {
        var endpointPromise: Q.Deferred<ServiceEndpoint_Contracts.ServiceEndpointRequestResult> = Q.defer<ServiceEndpoint_Contracts.ServiceEndpointRequestResult>();
        var verifyConnectionPromise = this._distributedTaskClient.beginExecuteServiceEndpointRequest(serviceEndpointRequest, endpointId);

        verifyConnectionPromise.then((result: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
            if ((Utils_String.equals(result.statusCode, "ok", true)) && ((result.errorMessage === undefined) || (Utils_String.equals(result.errorMessage, "", true)))) {
                this.verifyConnectionStatus(Resources.ConnectionStatusVerified);
            } else {
                this.verifyConnectionStatus(Resources.ConnectionStatusFailed);
                this.errors.push(result.errorMessage);
            }
            endpointPromise.resolve(result);
        }, (error) => {
            var errorMsg = error;
            if (!!error && !!error.serverError && !!error.serverError.innerException) {
                errorMsg = errorMsg + Utils_String.newLine + error.serverError.innerException.message;
            }

            endpointPromise.reject(new Error(errorMsg));
        });

        return endpointPromise.promise;
    }

    public getAzureSubscriptions(): IPromise<boolean> {
        var defer = Q.defer<boolean>();
        this.errors([]);
        this._distributedTaskClient.beginGetAzureSubscriptions().then((response: DistributedTask_Contracts.AzureSubscriptionQueryResult) => {
            if (!response.errorMessage) {
                // Sorting subscriptions based on display name
                const subscriptions = response.value.sort((a, b) => {
                    return a.displayName > b.displayName ? 1 : -1;
                });
                this.subscriptionList(subscriptions);
                defer.resolve(false);
            } else {
                this.errors.push(response.errorMessage);
                defer.resolve(true);
            }
        }, (error) => {
            this.errors.push(error.message);
            defer.resolve(true);
        });
        return defer.promise;
    }
    
    public getAzureSubscriptionsComboOptions = (): any => {
        const subscriptionAndIdList = this.subscriptionAndIdList.peek();
        if (this.subscriptionAndId.peek() === " (  )" && subscriptionAndIdList.length > 0) {
            this.subscriptionAndId(subscriptionAndIdList[0]);
        }

        var options = {
            allowEdit: false,
            mode: "drop",
            value: this.subscriptionAndId(),
            source: this.subscriptionAndIdList(),
            enabled: this.isAzureSubscriptionBasedInputsEnabled(),
            label: Resources.Subscription,
            change: (combo: Controls_Combos.Combo) => {
                this.subscriptionAndId(combo.getInputText());
            }
        };
        return options;
    }

    public getRegistries = (): IPromise<boolean> => {
        if (!this.refreshRegistriesList()) {
            return Q.resolve(true);
        }

        let deferred = Q.defer<boolean>();
        this.errors([]);
        this.registriesList([]);
        
        VSS.using(["DistributedTasksCommon/ServiceEndpoints/AzureRMEndpointsManageDialog"], (AzureRMEndpointsManageDialog: typeof AzureRMEndpointsManageDialog_NO_REQUIRE) => {
            let azureEndpointDialogModel = new AzureRMEndpointsManageDialog.AddAzureRmEndpointsModel(() => { return; });
            azureEndpointDialogModel.subscriptionId(this.subscriptionId());
            azureEndpointDialogModel.subscriptionName(this.subscriptionName());
            azureEndpointDialogModel.tenantId(this.subscriptionTenantId());
            azureEndpointDialogModel.serverUrl("https://management.azure.com/"); // we can get azureRm artifact type and get this url from it.
            
            const authInProgress = (authInProgress: boolean) => {
                this.isOAuthFlowInProgress(authInProgress);
            };            
    
            let serviceEndpointRegistriesRequest: ServiceEndpoint_Contracts.ServiceEndpointRequest = {
                serviceEndpointDetails: azureEndpointDialogModel.getServiceEndpointDetails(),
                dataSourceDetails: {
                    dataSourceName: "AzureRMContainerRegistries",
                    dataSourceUrl: "",
                    headers: null,
                    requestContent: null,
                    requestVerb: null,
                    resourceUrl: "",
                    parameters: null,
                    resultSelector: "",
                    initialContextTemplate: ""
                },
                resultTransformationDetails: null
            };
        
            AzureRMEndpointsManageDialog.AzureRmEndpointUtils.getAccessTokenKey(this._distributedTaskClient, this.subscriptionTenantId(), authInProgress, this.oauthAccessTokenKey())
                .then((accessTokenKey: string) => {
                    serviceEndpointRegistriesRequest.serviceEndpointDetails.authorization.parameters["accessTokenType"] = "AppToken";
                    if (!!accessTokenKey) {
                        this.isOAuthFlowInProgress(false);
                        this.oauthAccessTokenKey(accessTokenKey); 
                        serviceEndpointRegistriesRequest.serviceEndpointDetails.authorization.parameters["accesstoken"] = accessTokenKey;
                        serviceEndpointRegistriesRequest.serviceEndpointDetails.authorization.parameters["accessTokenFetchingMethod"] = ServiceEndpoint_Contracts.AccessTokenRequestType.Oauth.toString();
                    }
    
                    this._distributedTaskClient.beginExecuteServiceEndpointRequest(serviceEndpointRegistriesRequest, Utils_String.EmptyGuidString)
                        .then((response: ServiceEndpoint_Contracts.ServiceEndpointRequestResult) => {
                            if (!!response.errorMessage) {
                                this.errors.push(response.errorMessage);
                                deferred.reject(false);
                            }
                            else {
                                try {
                                    if (response.result) {
                                        response.result.forEach((registry) => {
                                            this.registriesList.push(JSON.parse(registry));
                                        });
                                    }
        
                                    this.refreshRegistriesList(false);
                                    deferred.resolve(true);
                                }
                                catch (e) {
                                    const errorMessage = Resources.ErrorWhileParsingListACRResponse + e.message;
                                    this.errors.push(errorMessage);
                                    deferred.resolve(false);
                                }
                            }
                        }, (error) => {
                            
                            let errorMsg = error;
                            if (!!error && !!error.serverError && !!error.serverError.innerException) {
                                errorMsg = errorMsg + Utils_String.newLine + error.serverError.innerException.message;
                            }
    
                            this.errors.push(errorMsg);
                            deferred.reject(false);
                        }
                    );
    
                }, (error) => {
                    // invalidate the access token key
                    this.oauthAccessTokenKey(Utils_String.empty);
                    let errorMessage = Resources.ErrorWhileAuthorizingOnSubscription;
                    if (!!error) {
                        errorMessage = errorMessage + " " + Resources.ErrorPrefix + error;
                    }

                    this.errors.push(errorMessage);   
                    deferred.reject(false);
                }
            );    
        });
        
        return deferred.promise;
    }

    public getRegistriesComboOptions = (): any => {
        var options = {
            allowEdit: false,
            mode: "drop",
            value: this.selectedRegistryName(),
            source: this.registryNamesList(),
            enabled: this.isAzureSubscriptionBasedInputsEnabled(),
            label: Resources.AzureContainerRegistryLabel,
            change: (combo: Controls_Combos.Combo) => {
                const selectedValue = combo.getInputText();
                if (selectedValue) {
                    const indexOfSelectedEntry = this.registryNamesList.peek().indexOf(selectedValue);
                    const selectedRegistry = this.registriesList.peek()[indexOfSelectedEntry];
                    this.selectedRegistryId(selectedRegistry.id);
                    this.selectedLoginServer(this.getLoginServerFromRegistry(selectedRegistry));
                }
            },
            refreshData: this.getRegistries
        };

        return options;
    }

    private getRegistryNameFromRegistryId(registryId: string): string {
        let registryName = Utils_String.empty;
        if (registryId) {
            let parts = registryId.split('/');
            let registryNameIndex = parts.findIndex(part => Utils_String.equals(part, "registries", true)) + 1;
            if (registryNameIndex > 0) {
                registryName = parts[registryNameIndex];
            }
        }

        return registryName;
    }

    private getLoginServerFromRegistry(registry: any): string {
        let loginServer = "";
        if (registry && registry.properties && registry.properties.loginServer) {
            loginServer = registry.properties.loginServer;
        }

        return loginServer;
    }

    public isAzureSubscriptionBasedInputsEnabled() : boolean {
        return this.allowUpdatingAzureSubscriptionBasedInputs() && !this.servicePrincipalSetupInProgress() && !this.isOAuthFlowInProgress();
    }

    public allowUpdatingAzureSubscriptionBasedInputs(): boolean {
        return !(this.isUpdate() && this.isExistingRegistryTypeACR());
    }

    public dispose() {
        this._disposalManager.dispose();
    }
}

export class AddDockerRegistryEndpointsDialog extends ServiceEndpoint_Controls.AddServiceEndpointDialog {
    protected _model: AddDockerRegistryEndpointModel;

    constructor(model: AddDockerRegistryEndpointModel) {
        super(model);
    }

    public initialize(): void {
        super.initialize();

        this._model.registrytype.subscribe(() => {
            if (this._model.allowUpdatingAzureSubscriptionBasedInputs() && this._model.isACR()) {
                this._model.getAzureSubscriptions().then((isFetchFailed) => {
                    if (isFetchFailed) {
                        this._element.find(".error-messages-div").show();
                    }
                });
            }
        });

        this._model.subscriptionId.subscribe(() => {
            this._model.refreshRegistriesList(true);
            this._model.selectedRegistryId(Utils_String.empty);
            this._model.selectedLoginServer(Utils_String.empty);
        });
    }

    public getTitle(): string {
        var title = Resources.DockerRegistryTitle;
        if (this._model.title != "") {
            title = this._model.title;
        }
        return title;
    }

    protected preCheck(): boolean {
        var checkFailed = false;

        // Input fields check
        this._element.find('input:visible').each((index: number, element: Element) => {
            // Skipping empty check for registry and email as these are not mandatory for some anonymous registry
            if ($(element).attr('id') !== "registry" && $(element).attr('id') !== "email" && $(element).attr('id') !== "pwd") {
                checkFailed = this._checkEmpty($(element));
            }

            return !checkFailed;
        });

        return checkFailed;
    }

    protected createServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        this._model.createServiceEndpoint().then((provisionEndpointResponse) => {
            defer.resolve(provisionEndpointResponse);
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    protected updateServiceEndpoint(): IPromise<ServiceEndpoint_Contracts.ServiceEndpoint> {
        var defer = Q.defer<ServiceEndpoint_Contracts.ServiceEndpoint>();

        this._model.updateServiceEndpoint().then((provisionEndpointResponse) => {
            defer.resolve(provisionEndpointResponse);
        }, (error) => {
            defer.reject(error);
        });

        return defer.promise;
    }

    protected getServiceEndpointDetails(): ServiceEndpoint_Common.ServiceEndpointDetails {
        return this._model.getServiceEndpoint();
    }

    protected createView(): JQuery {
        return $(AddDockerRegistryEndpointsDialog._add_docker_connection);
    }

    private static _add_docker_connection = `
    <div class="add_docker_connections_dialog services_dialog">
        <div id="connectionId" class="connectionId" data-bind="value: id, disable: isUpdate()"></div>
        <div data-bind="visible: servicePrincipalSetupInProgress()">
            <span class="icon status-progress" data-bind="visible: pollingInProgress()"></span>
            <span><strong>${Resources.ServicePrincipalSetupInProgress}</strong></span>
        </div>
        <table>
            <tr>
                <td>
                    <label for="registrytype" class="required-input">${Resources.DockerRegistryType}</label>
                </td>
                <td>
                    <div id="registrytype" role="radiogroup" data-bind="attr: {'aria-label': registryTypeSelectorText}">
                        <span>
                            <input role="radio" name="registryType" class="auth-kind" required type="radio" id="DockerHubType" value="DockerHub" data-bind="checked: registrytype, disable: servicePrincipalSetupInProgress(), attr: { 'aria-checked': (registrytype() === 'DockerHub') ? 'true' : 'false' }" />
                            <label for="DockerHubType">${Resources.DockerHub}</label>
                        </span>
                        <span>
                            <input role="radio" name="registryType" class="auth-kind" required type="radio" id="OthersType" value="Others" data-bind="checked: registrytype, disable: servicePrincipalSetupInProgress(), attr: { 'aria-checked': (registrytype() === 'Others') ? 'true' : 'false' }" />
                            <label for="OthersType">${Resources.DockerRegistryOthers}</label>
                        </span>
                        <span data-bind="visible: showAzureSubscriptionBasedOption()">
                            <input role="radio" name="registryType" class="auth-kind" required type="radio" id="ACRType" value="ACR" data-bind="checked: registrytype, disable: servicePrincipalSetupInProgress(), attr: { 'aria-checked': (registrytype() === 'ACR') ? 'true' : 'false' }" />
                            <label for="ACRType">${Resources.AzureContainerRegistry}</label>
                        </span>
                    </div>
                </td>
            </tr>

            <tr>
                <td>
                    <label for="connectionName" class="required-input">${Resources.ConnectionName}</label></td>
                <td>
                    <input class="textbox" data-bind="value: name, css: { 'invalid': !name() }, valueUpdate: ['blur', 'afterkeydown'], disable: servicePrincipalSetupInProgress()" required id="connectionName" type="text" />
            </tr>

            <tr data-bind="visible: !isACR()">
                <td>
                    <label for="registry">${Resources.DockerRegistry}</label></td>
                <td>
                    <input class="textbox" required id="registry" type="text" data-bind="value: registry, disable: isDockerHub()" /></td>
                <td class="helpMarkDown" data-bind="showTooltip: { text: dockerRegistryHelpMarkdown, minWidth: 200, pivotSiblingCssClass: 'value-field' }"></td>
            </tr>
            <tr data-bind="visible: !isACR()">
                <td>
                    <label for="username">${Resources.DockerId}</label></td>
                <td>
                    <input class="textbox" required id="username" type="text" data-bind="value: userName" /></td>
            </tr>
            <tr data-bind="visible: !isACR()">
                <td>
                    <label for="pwd">${Resources.DockerPassword}</label></td>
                <td>
                    <input class="textbox" required id="pwd" type="password" data-bind="attr: { placeholder: isUpdate() ? '********' : '' }, value: pwd" /></td>
            </tr>
            <tr data-bind="visible: !isACR()">
                <td style="min-width:150px">
                    <label for="email">${Resources.DockerEmail}</label></td>
                <td>
                    <input class="textbox" required id="email" type="text" data-bind="value: email" /></td>
            </tr>

            <tr data-bind="visible: isACR()">
                <td>
                    <label class="required-input">${Resources.AzureSubscriptionLabel}</label>
                </td>
                <td>
                    <div class="pick-list grid-row-element-col2" data-bind="dtcCombo: getAzureSubscriptionsComboOptions()"></div>
                </td>
                <td class="helpMarkDown" data-bind="showTooltip: { text: dockerRegistryAzureSubscriptionHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tr data-bind="visible: isACR()" class="input-required">
                <td>
                    <label class="required-input">${Resources.AzureContainerRegistryLabel}</label>
                </td>
                <td>
                    <div class="pick-list grid-row-element-col2" data-bind="dtcFetchingCombo: getRegistriesComboOptions()"></div>
                </td>
                <td class="helpMarkDown" data-bind="showTooltip: { text: azureContainerRegistryHelpText, minWidth: 200, pivotSiblingCssClass: 'value-field' }">
                </td>
            </tr>

            <tbody class="verify-connection-container" data-bind="visible: showVerifyConnection()">
                <tr>
                    <td class="header-line td" colspan="3">
                        <div class="header"></div>
                    </td>
                </tr>
                <tr>
                    <td style="min-width:150px">
                        <div class="verify-connection-status">
                            <span>${Resources.DockerConnectionLabel}</span>
                            <span class="bowtie-icon dialog-field-tooltip" data-bind="css: verifyConnectionStatusCssIconClass"></span>
                            <span class="status-main" data-bind="text: verifyConnectionStatus, css: verifyConnectionStatusCssTextClass"></span>
                        </div>
                    </td>
                    <td>
                        <div class="verify-action">
                            <span data-bind="click: verifyConnection, event: { keydown: onKeyDown }"><a tabindex="0" role="button">${Resources.DockerVerifyConnection}</a></span>
                        </div>
                    </td>
                </tr>
                <tr>
                    <td class="footer-line td" colspan="3">
                        <div class="footer"></div>
                    </td>
                </tr>
            </tbody>

        </table>
        <div tabindex="0" class="error-messages-div">
            <div data-bind="foreach: errors">
                <span role="alert" data-bind="text: $data"></span><br />
            </div>
        </div>
        <div tabindex="0" class="operation-status-message-div" data-bind="visible: isACR() && operationStatusMessage">
                <span role="alert" data-bind="text: operationStatusMessageWithPrefix"></span><br />
        </div>
    </div>`;
}

VSS.tfsModuleLoaded("DockerRegistryManageDialog", exports);